import React from "react"
import { Redirect, Route, Switch } from "react-router-dom"
import BaseLayout from "src/layouts/Base"
import Plans from "src/containers/Plans"
import withRouteValidation from "src/hocs/withRouteValidation"
import {
  PLANS_URL,
  PLANS_ID_URL,
  PLANS_ID_CALENDAR_URL,
  PLANS_ID_CALENDAR_DATE_REDIRECT_URL,
  PLANS_ID_CALENDAR_SETTINGS_URL,
  PLANS_ID_CALENDAR_EVENTS_URL,
  PLANS_ID_CALENDAR_EVENT_URL,
  PLANS_ID_CALENDAR_DATE_URL,
  DEFAULT_ID_VALIDATION_CONFIG,
  PLANS_ID_CALENDAR_EVENT_URL_VALIDATION_CONFIG,
  PLANS_ID_URL_VALIDATION_CONFIG,
} from "src/constants/routeNames"
import { URL_DATE_FORMAT } from "src/containers/Calendar/constants"
import Calendar from "src/containers/Calendar"
// import Event from "src/containers/Event"
import PlanSettings from "src/containers/PlanSettings"
import PlanEvents from "src/components/PlanEvents"
import moment from "moment"
import NotFoundPage from "src/components/pages/NotFound"

const WrappedPlanPage = withRouteValidation({
  routeValidationConfig: DEFAULT_ID_VALIDATION_CONFIG,
})(Plans)

/* eslint-disable react/destructuring-assignment */
const PlanCalendarEvent = props => (
  <Calendar {...props} planId={props.match.params.planId} />
)
// props.match.params.id === `new` ? (
//   <Calendar {...props} planId={props.match.params.planId} />
// ) : (
//   <Event {...props} planId={props.match.params.planId} />
// )

const PlanCalendarDate = props =>
  moment(props.match.params.date, URL_DATE_FORMAT, true).isValid() ? (
    <Calendar
      {...props}
      planId={props.match.params.planId}
      scale={props.match.params.scale}
      date={props.match.params.date}
    />
  ) : (
    <NotFoundPage />
  )
/* eslint-enable react/destructuring-assignment */

export default (
  <Route path={PLANS_URL}>
    <BaseLayout title="Планы">
      <Switch>
        <Route
          path={PLANS_ID_CALENDAR_SETTINGS_URL}
          component={withRouteValidation({
            routeValidationConfig: DEFAULT_ID_VALIDATION_CONFIG,
          })(props => (
            <PlanSettings {...props} />
          ))}
        />
        <Route
          path={PLANS_ID_CALENDAR_EVENTS_URL}
          component={withRouteValidation({
            routeValidationConfig: DEFAULT_ID_VALIDATION_CONFIG,
          })(props => (
            <PlanEvents {...props} />
          ))}
        />
        <Route
          path={PLANS_ID_CALENDAR_EVENT_URL}
          component={withRouteValidation({
            routeValidationConfig: PLANS_ID_CALENDAR_EVENT_URL_VALIDATION_CONFIG,
          })(PlanCalendarEvent)}
        />
        <Route
          path={PLANS_ID_CALENDAR_DATE_URL}
          component={withRouteValidation({
            routeValidationConfig: PLANS_ID_URL_VALIDATION_CONFIG,
          })(PlanCalendarDate)}
        />
        <Redirect
          from={PLANS_ID_CALENDAR_URL}
          to={PLANS_ID_CALENDAR_DATE_REDIRECT_URL}
        />
        <Route path={PLANS_URL} exact component={Plans} />
        <Route path={PLANS_ID_URL} component={WrappedPlanPage} />
      </Switch>
    </BaseLayout>
  </Route>
)
